import React, { useEffect } from "react";
import { Form as FormStyled, Container, ErrorMessage } from "./styles";
import {
  Button,
  Input,
  FormLoginTitle,
  LoadingButton,
} from "components/shared";
import { Box, Paper, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useFormik } from "formik";
import * as yup from "yup";
import { useSession } from "context/SessionContext";

const useStyles = makeStyles((theme) => ({
  arrowIcon: {
    marginRight: "8px",
    color: "var(--color-gray)",
    "&:hover": {
      color: "var(--color-gray-dark)",
      cursor: "pointer",
    },
  },
  paper: {
    "&.MuiPaper-outlined": {
      border: "none",
    },
    boxShadow: `rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px`,
  },
}));

const validationSchema = yup.object().shape({
  login: yup
    .string()
    // .email('Digite um e-mail com formato válido!')
    .required("Campo obrigatório!"),
  password: yup
    .string()
    .min(6, "Mínimo de 6 caracteres!")
    .required("Campo obrigatório!"),
  keepConected: yup.boolean(),
});

interface formValuesTypes {
  login: string;
  password: string;
  keepConected: boolean;
}

const initialState: formValuesTypes = {
  login: "",
  password: "",
  keepConected: true,
};

export default function Form() {
  const classes = useStyles();
  const { signIn, errorMessage, loading } = useSession();

  const formik = useFormik({
    initialValues: initialState,
    validationSchema: validationSchema,
    onSubmit: (values) =>
      signIn({
        login: values.login,
        password: values.password,
        keep: values.keepConected,
      }),
  });

  // função para eviar formulario com enter

  useEffect(() => {
    const listener = (event: any) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        formik.handleSubmit();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [formik]);

  // função para eviar formulario com enter

  return (
    <Box display="flex" flexDirection="column">
      <Paper variant="outlined" className={classes.paper}>
        <FormStyled onSubmit={formik.handleSubmit}>
          <Container>
            <FormLoginTitle>Login</FormLoginTitle>
            <FormLoginTitle>Administrador</FormLoginTitle>
          </Container>
          <Box flexDirection="column">
            <Grid container spacing={3} style={{ marginBottom: "24px" }}>
              <Grid item xs={12}>
                <Input
                  textTransform="inherit"
                  value={formik.values.login}
                  onChange={formik.handleChange}
                  error={formik.touched.login && Boolean(formik.errors.login)}
                  helperText={formik.touched.login && formik.errors.login}
                  label="Usuário"
                  id="login"
                  name="login"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <Input
                  textTransform="inherit"
                  type="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.password && Boolean(formik.errors.password)
                  }
                  helperText={formik.touched.password && formik.errors.password}
                  label="Senha"
                  id="password"
                  name="password"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
            </Grid>

            {!loading ? (
              <Button fullWidth type="submit">
                ENTRAR
              </Button>
            ) : (
              <LoadingButton fullWidth disabled={loading} />
            )}
          </Box>
        </FormStyled>
      </Paper>

      {errorMessage && (
        <Box mt={2} textAlign="center">
          <ErrorMessage>{errorMessage}</ErrorMessage>
        </Box>
      )}
    </Box>
  );
}
